var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import CardMaterialEducationAPI from './card-material-education-api';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Image, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { resolvePath } from '@philips-internal/oswald-ui-utils';
import './card-material-education.css';
let CardMaterialEducation = class CardMaterialEducation extends Component {
    static { this.propTypes = {
        className: string,
        dsData: string,
        dsImage: string,
        dsPrePos: string,
        dsSubTitulo: string,
        dsTexto: string,
        dsTitulo: string,
        nrSequencia: number,
        uuid: string,
        width: number
    }; }
    render() {
        const { dsPrePos, dsImage, dsData, dsSubTitulo, dsTitulo } = this.props;
        const preparation = 'PRE';
        const GET_PREVIEW_DOCUMENT = '/patient-service/resources/temporary/preview-storage';
        const iconPatch = '/static/assets/icons/DLS_Articles.svg';
        const imagePatch = dsImage ? resolvePath(`${GET_PREVIEW_DOCUMENT}?type=ME&uri=:uri`, { uri: dsImage }) : iconPatch;
        const imageClassName = dsImage ? 'upload-image' : 'articles-icon';
        const categoryExpression = preparation === dsPrePos ? MessageService.translate('patient.education.preparation') : MessageService.translate('patient.education.procedure');
        const categoryClassName = preparation === dsPrePos ? 'category-content-pre' : 'category-content-pro';
        return (React.createElement("div", { className: 'card-material-education' },
            React.createElement("div", { className: 'upper-content' },
                React.createElement(Image, { className: imageClassName, src: imagePatch, alt: '' })),
            React.createElement("div", { className: 'middle-content' },
                React.createElement(Text, { className: categoryClassName }, categoryExpression),
                React.createElement(Text, { className: 'title-text' }, dsTitulo),
                React.createElement(Text, { className: 'subtitle-text' }, dsSubTitulo)),
            React.createElement("div", { className: 'lower-content' },
                React.createElement(Text, { className: 'date-text' }, dsData),
                React.createElement(Text, { className: 'read-more' }, MessageService.translate('patient.read-more')))));
    }
};
CardMaterialEducation = __decorate([
    AwesomeComponent({ api: CardMaterialEducationAPI, type: ComponentType.DATA_DISPLAY })
], CardMaterialEducation);
export default CardMaterialEducation;
//# sourceMappingURL=card-material-education.js.map